import { render } from "./CenteredTextImageSection.vue?vue&type=template&id=60e55314&scoped=true"
import script from "./CenteredTextImageSection.vue?vue&type=script&lang=js"
export * from "./CenteredTextImageSection.vue?vue&type=script&lang=js"

import "./CenteredTextImageSection.vue?vue&type=style&index=0&id=60e55314&scoped=true&lang=css"

import exportComponent from "../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.4.38_vue@3.2.13_webpack@5.94.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-60e55314"]])

export default __exports__